import React from "react";
import PropTypes from "prop-types";
import CustomStatus from "./CustomStatus";
import CustomBadge from "./CustomBadge";
import Actions from "./Actions";
import { FluentTooltip } from "../../../../components/FluentUI/Fluent-Tooltip";

export const initialDataState = {
    sort: [],
    take: 10,
    skip: 0,
    filter: {
        logic: "and",
        filters: [],
    },
};

export const CustomCell = (column, { dataItem }) => {
    if (column.trim().toLowerCase() === "status") {
        return CustomStatusCell(dataItem);
    } else {
        return (
            <td data-testid="fluent-tooltip">
                <FluentTooltip
                    target={<td className="k-table-td">{dataItem[column]?? ""}</td>}
                    text={dataItem[column] ?? ""}
                />
            </td>
        );
  };
};

const CustomStatusCell = (dataItem) => {
    return (
        <td className="k-table-td td-status" data-testid="custom-status">
            <CustomStatus status={dataItem.Status} />
        </td>
    );
};

export const CustomNamesCell = (column, { dataItem }) => {
    return (
        <td className="k-table-td td-status" data-testid="custom-badge">
            <div className="organization-badgename-container">
                {
                    dataItem[column]?.map(name => {
                        return <CustomBadge name={name} key={`${column}-${name}`} />
                    })
                }
            </div>
        </td>
    );
};

export const CustomActionsCell = ({ dataItem }, route, fetchEndpoint, type, canArchive, canEdit) => {
  return (
    <td className="k-table-td td-actions" data-testid="actions">
      <Actions
        id={dataItem.Id}
        route={`${route}${dataItem.Id}`}
        fetchEndpoint={fetchEndpoint}
        type={type}
        canArchive={canArchive}
        canEdit={canEdit}
      />
    </td>
  );
};

CustomCell.propTypes = {
    column: PropTypes.string.isRequired,
    dataItem: PropTypes.object.isRequired,
};

CustomStatusCell.propTypes = {
    dataItem: PropTypes.object.isRequired,
};

CustomNamesCell.propTypes = {
    column: PropTypes.string.isRequired,
    dataItem: PropTypes.object.isRequired,
};

CustomActionsCell.propTypes = {
    dataItem: PropTypes.object,
    route: PropTypes.string,
    fetchEndpoint: PropTypes.func,
    type: PropTypes.string,
};
